import { render, staticRenderFns } from "./DragUpload.vue?vue&type=template&id=b4c37cf0&scoped=true&"
import script from "./DragUpload.vue?vue&type=script&lang=js&"
export * from "./DragUpload.vue?vue&type=script&lang=js&"
import style0 from "./DragUpload.vue?vue&type=style&index=0&id=b4c37cf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c37cf0",
  null
  
)

export default component.exports